/** Placeholder for factory sub-modules that are being prepared. */
export default function FactoryPlaceholder({ slug, title, description, icon: Icon }) {
  return (
    <div
      data-testid={`factory-page-${slug}`}
      className="flex h-full flex-col items-center justify-center px-6 py-16 text-center"
    >
      <span className="mb-5 grid h-16 w-16 place-items-center rounded-2xl border border-dashed border-cyan-500/30 bg-cyan-500/5 text-cyan-400">
        <Icon size={26} />
      </span>
      <h2 className="font-display text-lg font-semibold text-white">{title}</h2>
      <p className="mt-1.5 max-w-sm text-[12.5px] text-slate-400">{description}</p>
      <p className="mono mt-4 text-[9.5px] uppercase tracking-[0.22em] text-slate-600">
        Module under preparation
      </p>
    </div>
  );
}
